import { endPoints, methods } from "../../environment"
import generateApiSliceAndThunk from "../../thunk"

const { slice: createTicketCodeSlice, request: createTicketCodeRequest } =
  generateApiSliceAndThunk(
    "createTicketCodeSlice",
    endPoints.createTicketCode,
    methods.get
  )

const { slice: createPresignUrlSlice, request: createPresignUrlRequest } =
  generateApiSliceAndThunk(
    "createPresignUrlSlice",
    endPoints.createPresignUrl,
    methods.post
  )
const { slice: createTicketSlice, request: createTicketRequest } =
  generateApiSliceAndThunk(
    "createTicketSlice",
    endPoints.createTicket,
    methods.post
  )
const { slice: issueTypesSlice, request: issueTypesRequest } =
  generateApiSliceAndThunk(
    "issueTypesSlice",
    endPoints.getIssueTypes,
    methods.get
  )
const { slice: getPlatformListSlice, request: getPlatformListRequest } =
  generateApiSliceAndThunk(
    "getPlatformListSlice",
    endPoints.getPlatforms,
    methods.get
  )
const { slice: getTicketListSlice, request: getTicketListRequest } =
  generateApiSliceAndThunk(
    "getTicketListSlice",
    endPoints.getTicketList,
    methods.get
  )
const { slice: getTicketDetailsSlice, request: getTicketDetailsRequest } =
  generateApiSliceAndThunk(
    "getTicketDetailsSlice",
    endPoints.getTicketDetails,
    methods.get
  )
const { slice: ticketReplySlice, request: ticketReplyRequest } =
  generateApiSliceAndThunk(
    "ticketReplySlice",
    endPoints.ticketReply,
    methods.post
  )
const { slice: reopenTicketSlice, request: reOpenTicketRequest } =
  generateApiSliceAndThunk(
    "reopenTicketSlice",
    endPoints.reOpenTicket,
    methods.put
  )
const { slice: getRemoveAccessSlice, request: getRemoveAccessRequest } =
  generateApiSliceAndThunk(
    "getRemoveAccessSlice",
    endPoints.getRemoveAccessRequest,
    methods.get
  )
const { slice: updateRemoteStatusSlice, request: updateRemoteStatusRequest } =
  generateApiSliceAndThunk(
    "updateRemoteStatusSlice",
    endPoints.changeRemoteAccessStatus,
    methods.put
  )
const { slice: remoteAccessLogsSlice, request: remoteAccessLogsRequest } =
  generateApiSliceAndThunk(
    "remoteAccessLogsSlice",
    endPoints.getRemoteLogs,
    methods.get
  )

export {
  createPresignUrlRequest,
  createPresignUrlSlice,
  createTicketCodeRequest,
  createTicketCodeSlice,
  createTicketRequest,
  createTicketSlice,
  getPlatformListRequest,
  getPlatformListSlice,
  getRemoveAccessRequest,
  getRemoveAccessSlice,
  getTicketDetailsRequest,
  getTicketDetailsSlice,
  getTicketListRequest,
  getTicketListSlice,
  issueTypesRequest,
  issueTypesSlice,
  reOpenTicketRequest,
  remoteAccessLogsRequest,
  remoteAccessLogsSlice,
  reopenTicketSlice,
  ticketReplyRequest,
  ticketReplySlice,
  updateRemoteStatusRequest,
  updateRemoteStatusSlice,
}
